const routes = [
    {
        path: "/20/dzp",
        children: [
            {
                path: "20_20241203khysj",
                component: () => import("@/views/20/dzp/20241203/index.vue"),
                meta: {
                    sign: "20_20241203khysj",
                },
            },
            {
                path: "20_20241203khgch",
                component: () => import("@/views/20/dzp/20241203/index.vue"),
                meta: {
                    sign: "20_20241203khgch",
                },
            },
            {
                path: "20_20250618khysj",
                component: () => import("@/views/20/dzp/20250618/index.vue"),
                meta: {
                    sign: "20_20250618khysj",
                },
            },
            {
                path: "20_20250618khgch",
                component: () => import("@/views/20/dzp/20250618/index.vue"),
                meta: {
                    sign: "20_20250618khgch",
                },
            },
            {
                path: "20_20250618khyzy",
                component: () => import("@/views/20/dzp/20250618yzy/index.vue"),
                meta: {
                    sign: "20_20250618khyzy",
                },
            },
            {
                path: "20_20250703khyzy",
                component: () => import("@/views/20/dzp/20250703yzy/index.vue"),
                meta: {
                    sign: "20_20250703khyzy",
                },
            },
        ],
    },
];

export default routes;
